module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"managing-partners":"Sócios","managing-partner":"Sócio {number}"},"en-US":{"managing-partners":"Managing partners","managing-partner":"Managing Partner {number}"}}')
  delete Component.options._Ctor
}
